import React, { useMemo, useState } from "react";
// import { Link } from "react-router-dom";
import objectPath from "object-path";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import { toAbsoluteUrl } from "../../../_helpers";
import { DoubleArrowRounded } from "@material-ui/icons";
import { IconButton } from "@material-ui/core";
import { Link } from "react-router-dom";

export function Brand() {
    const uiService = useHtmlClassService();

    const [click, setClick] = useState(true);

    const layoutProps = useMemo(() => {
        return {
            brandClasses: uiService.getClasses("brand", true),
            asideSelfMinimizeToggle: objectPath.get(uiService.config, "aside.self.minimize.toggle"),
            headerLogo: uiService.getLogo(),
            headerStickyLogo: uiService.getStickyLogo(),
        };
    }, [uiService]);

    return (
        <>
            {/* begin::Brand */}
            <div className={`brand flex-column-auto ${layoutProps.brandClasses}`} id="kt_brand">
                {/* begin::Logo */}

                <Link to="/">
                    {click === true ? (
                        <img
                            alt="logo"
                            src={toAbsoluteUrl("/media/logos/hch-logo.png")}
                            style={{ objectFit: "scale-down", width: 60 }}
                        />
                    ) : (
                        <img
                            alt="logo"
                            src={toAbsoluteUrl("/media/logos/hch-logo.png")}
                            style={{ objectFit: "scale-down", width: 60 }}
                        />
                    )}
                </Link>

                {/* <Link to="" className="brand-logo">
          <img alt="logo" src={layoutProps.headerLogo} />
        </Link> */}
                {/* end::Logo */}

                {layoutProps.asideSelfMinimizeToggle && (
                    <>
                        {/* begin::Toggle */}
                        <div
                            className="brand-toggle btn btn-sm px-0"
                            id="kt_aside_toggle"
                            onClick={() => setClick(!click)}
                            role="button"
                        >
                            <span className="svg-icon svg-icon-xl m-0">
                                <IconButton size="small" style={{ color: "white", transform: "rotate(180deg)" }}>
                                    <DoubleArrowRounded />
                                </IconButton>
                            </span>
                        </div>
                        {/* end::Toolbar */}
                    </>
                )}
            </div>
            {/* end::Brand */}
        </>
    );
}
